import { RootAppState } from '../types';

export const isLoaderVisibility = (state: RootAppState) => state.loader.isLoaded;
